import {
  hideLoading,
  showAlert,
  showLoading,
} from "../Actions/GeneralActions";
import Axios from "axios";
import Apis from "../../config/APIs";
import { getHeaders } from "../../utills";
import { getYardsaleDetails, getYardsalesList, onDeactivateYardsale } from "../Actions/YardsalesAction";
import { deactivateUserYardsale } from "../Actions/DashboardActions";

export const YardsaleMiddleware = {

  onGetYardsales: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const query = new URLSearchParams();
          query.append('limit', params.limit);
          query.append('page', params.page);

          const data = await Axios.get(Apis.getYardSales(query.toString()), await getHeaders());

          if (data?.status == 200) {
            resolve(true);
            dispatch(getYardsalesList(data?.data?.data));
          }
        } catch (error) {
          console.log("errr", error?.response?.data?.message);

          reject(error);
          dispatch(
            showAlert({
              title: "yardsales list",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  onDeactivateYardsale: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const query = new URLSearchParams();
          query.append('id', params.id);
          query.append('reason', params.reason);

          const data = await Axios.patch(Apis.getYardSales(query.toString()), {}, await getHeaders());

          if (data?.status == 200) {
            resolve(true);
            if (params?.key == "user_yardsale") {
              dispatch(deactivateUserYardsale(data?.data?.data));
            }
            else {
              dispatch(onDeactivateYardsale(data?.data?.data));
            }
          }
        } catch (error) {
          console.log("errr", error?.response?.data?.message);

          reject(error);
          dispatch(
            showAlert({
              title: "deactivate yardsale",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  onGetYardsaleDetails: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const query = new URLSearchParams();
          query.append('id', params.id);
          const data = await Axios.get(Apis.getYardSales(query.toString()), await getHeaders());

          if (data?.status == 200) {
            resolve(true);
            dispatch(getYardsaleDetails(data?.data?.data));
          }
        } catch (error) {
          console.log("errr", error?.response?.data?.message);

          reject(error);
          dispatch(
            showAlert({
              title: " yardsale details",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },





};
